'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _dec3, _class, _desc, _value, _class2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reactI18next = require('react-i18next');

var _reduxForm = require('redux-form');

var _contacts = require('redux/modules/contacts');

var _components = require('components');

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var GroupForm = (_dec = (0, _reactRedux.connect)(null, { addGroup: _contacts.addGroup }), _dec2 = (0, _reduxForm.reduxForm)({
  form: 'groupForm',
  propNamespace: 'groupForm',
  initialValues: { name: '' }
}), _dec3 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = _dec3(_class = (_class2 = (_temp = _class3 = function (_Component) {
  (0, _inherits3.default)(GroupForm, _Component);

  function GroupForm() {
    (0, _classCallCheck3.default)(this, GroupForm);
    return (0, _possibleConstructorReturn3.default)(this, (GroupForm.__proto__ || (0, _getPrototypeOf2.default)(GroupForm)).apply(this, arguments));
  }

  (0, _createClass3.default)(GroupForm, [{
    key: 'addGroup',
    value: function addGroup(formData) {
      var reset = this.props.groupForm.reset;
      var name = formData.name;

      var promise = this.props.addGroup(name).promise;
      promise.then(reset);
      return promise;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          t = _props.t,
          _props$groupForm = _props.groupForm,
          handleSubmit = _props$groupForm.handleSubmit,
          submitting = _props$groupForm.submitting,
          invalid = _props$groupForm.invalid;


      return _react2.default.createElement(
        'form',
        { className: 'table', onSubmit: handleSubmit(this.addGroup) },
        _react2.default.createElement(
          'div',
          { className: 'table-cell' },
          _react2.default.createElement(
            'div',
            { className: 'formLabel' },
            t('Group name'),
            ':'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'table-cell' },
          _react2.default.createElement(_reduxForm.Field, { component: 'input', name: 'name', type: 'text', className: 'width-perc-100' }),
          _react2.default.createElement(
            'div',
            { className: 'hint small' },
            t('Add additional group here.')
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'table-cell' },
          _react2.default.createElement(
            'button',
            { type: 'submit', className: 'btn btn-simple squared small margin-left-5 pos-rel', disabled: submitting || invalid },
            t('Add'),
            submitting && _react2.default.createElement(_components.Loader, { small: true, mask: true })
          )
        )
      );
    }
  }]);
  return GroupForm;
}(_react.Component), _class3.propTypes = {
  addGroup: _propTypes2.default.func,
  groupForm: _propTypes2.default.object,
  t: _propTypes2.default.func
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'addGroup', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'addGroup'), _class2.prototype)), _class2)) || _class) || _class) || _class);
exports.default = GroupForm;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Contacts/Groups/GroupForm.js
// module id = 2152
// module chunks = 1